<template>
<div class="hidden w-full sidebar sticky top-0 lg:flex md:flex-col min-h-screen ">
    <div @click="$router.push({ name: 'Home' })" class="flex cursor-pointer justify-center my-4">
        <div class="image px-4">
            <img class="object-cover" :src="tenantLogo" alt="" />
        </div>
    </div>
    <div class="text-left">
        <router-link id="learner_web_dashboard" class="nav-item" :class="{ active: activePath == '/learner' }" to="/learner">
            <i class="fas fa-home mr-4 mt-1"></i>
            <span>Dashboard</span>
        </router-link>
        <p class="nav-item cursor-pointer text-white ml-5 py-4" @click="showProgram = !showProgram" data-intro="Here you can: -View Programs and take courses" data-step="1">
            <i class="fas fa-user-graduate mr-3 mt-1"></i>
            <span>Programs and Courses</span>
            <i v-if="showProgram" class="ml-3 fas fa-arrow-up"></i>
            <i v-else class="ml-3 fas fa-arrow-down"></i>
        </p>

        <main class="my-2" v-show="showProgram">
            <!-- <router-link id="learner_web_programs" class="nav-item px-8" :class="{ active: activePath.match('/learner/programs') }" to="/learner/programs">
                <span class="ml-6"></span>
                <i class="fas fa-layer-group mr-4 mt-1"></i>
                <span>Programs </span>
            </router-link> -->
<!--            <router-link id="learner_web_courses" class="nav-item" :class="{ active: activePath.match('/learner/course') }" to="/learner/courses">-->
<!--                <span class="ml-6"></span>-->
<!--                <i class="fab fa-discourse mr-4 mt-1"></i>-->
<!--                <span>Courses </span>-->
<!--            </router-link>-->
            <router-link id="learner_web_courses_mine" class="nav-item" :class="{ active: activePath.match('/learner/my-courses') }" :to="{ name: 'learner-enrolled-courses' }">
                <span class="ml-6"></span>
                <i class="fab fa-leanpub mr-4 mt-1"></i>
                <span>My Courses </span>
            </router-link>
            <!-- <router-link id="learner_web_webinar" class="nav-item" :class="{ active: activePath.match('/learner/webinar') }" to="/learner/webinar">
                <span class="ml-6"></span>
                <i class="fas fa-play-circle mr-4 mt-1"></i>
                <span>Webinar </span>
            </router-link> -->
            <!-- <router-link id="learner_web_submissions" class="nav-item" :class="{ active: activePath.match('/learner/submissions') }" to="/learner/submissions">
                <span class="ml-6"></span>
                <i class="fas fa-file-archive mr-4 mt-1"></i>
                <span>Submissions </span>
            </router-link> -->
        </main>

        <!-- <router-link id="learner_web_leaderboard" class="nav-item" :class="{ active: activePath.match('/learner/leaderboard/') }" :to="{ name: 'learner-leaderboard-home' }">
            <i class="fas fa-poll mr-4 mt-1"></i>
            <span>Leaderboard</span>
        </router-link> -->

        <!-- <router-link id="learner_web_board" :class="{ active: activePath.match('/learner/discussion') }" class="nav-item" :to="{ name: 'learner-discussion-home' }">
            <i class="fas fa-comments mr-4 mt-1"></i>
            <span>Discussion Boards</span>
        </router-link> -->
        <router-link id="learner_web_journal" :class="{ active: activePath.match('/learner/notes') }" class="nav-item" :to="{ name: 'learner-notes-home' }">
            <i class="far fa-sticky-note mr-4 mt-1"></i>
            <span>Learning Journal</span>
        </router-link>
        <router-link v-show="hasGrowthPlans" id="learner_web_growth_plan" :class="{ active: activePath.match('/learner/growth_plan') }" class="nav-item" :to="{ name: 'learner-growthplan-home' }">
            <i class="fa fa-chart-line mr-4 mt-1"></i>
            <span> Growth Plans</span>
        </router-link>

        <!-- <router-link id="learner_web_todo" :class="{ active: activePath.match('/learner/todo') }" class="nav-item" :to="{ name: 'learner-todo-home' }">
            <i class="fas fa-list-ol mr-4 mt-1"></i>
            <span>To do Lists</span>
        </router-link> -->
        <router-link id="learner_web_completion" :class="{ active: activePath.match('/learner/completion') }" class="nav-item" :to="{ name: 'learner-completion' }">
            <i class="fas fa-list-ol mr-4 mt-1"></i>
            <span>Completion</span>
        </router-link>
        <!-- <router-link id="learner_web_cart" :class="{ active: activePath.match('/learner/cart') }" class="nav-item" :to="{ name: 'learner-cart' }">
            <i class="fas fa-cart-plus mr-4 mt-1"></i>
            <span>Cart</span>
        </router-link> -->
        <!-- <router-link id="learner_web_wishlist" :class="{ active: activePath.match('/learner/wishlist') }" class="nav-item" :to="{ name: 'learner-wishlist' }">
            <i class="fas fa-list-ol mr-4 mt-1"></i>
            <span>Wishlist</span>
        </router-link> -->
        <!-- <router-link id="learner_web_notification_settings" :class="{ active: activePath.match('/learner/notification-settings') }" class="nav-item" :to="{ name: 'learner-notification-settings' }">
            <span><i class="fas fa-bell-slash mr-4"></i></span>
            <span>Notification Settings</span>
        </router-link> -->
    </div>
</div>
</template>

<script>
//import "intro.js/minified/introjs.min.css";
import SettingsMixin from "@/mixins/SettingsMixin";
import {
    mapGetters
} from "vuex";
export default {
    mixins: [SettingsMixin],
    props: {
        showNav: false,
    },
    data() {
        return {
            active: "",
            showProgram: false,
            navs: [
                "Admin ",
                "Tenant Management",
                // "To-do Lists",
                // "Reports & Analytics",
                // "Roles & Permissions",
                // "Grading",
                // "Rewards",
                // "Data Warehouse",
                // "Programs & Courses"
            ],
            LMSUserItem: JSON.parse(localStorage.getItem("lms-user"))
        };
    },
    mounted() {
        this.$Bus.$on("start-learner", () => {
            this.showProgram = true;
        });
    },
    methods: {
        startIntro() {
            // const introJS = require("intro.js");
            // introJS.introJs().start();
        },
        hasGrowthPlans() {
            if (this.LMSUserItem.default_program == "4f1b9237-da53-4812-be86-841bee6a8971") {
                return true;
            } else {
                return false;
            }
        },
    },
    computed: {
        ...mapGetters({
            userRole: "getUserRole",
        }),
        activePath() {
            return this.$route.path;
        },
        matcher() {
            return this.$route.matched.some((item) => item == "user");
        },
    },
};
</script>

<style lang="scss" scoped>
.image {
    height: 100%;

    img {
        width: 100%;
    }
}

.sidebar {
    flex: 0 0 235px;
    height: 200px;
    overflow-y: auto;
}
</style>
